<template>
  <div class="lean-publish lean-publish__container">
    <v-btn :disabled="!active" @click="publish()" outlined> Publish </v-btn>
    <v-dialog v-model="showProgressDialog" persistent width="300">
      <v-card>
        <v-toolbar color="blue-grey darken-1" dark flat>
          <v-toolbar-title>{{ $t('publisher.headline') }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-5">
          <div class="pb-5">
            <v-progress-linear
              stream
              background-color="blue-grey lighten-3"
              color="blue-grey"
              :value="progress"
              buffer-value="0"
              height="10"
            />
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import publishMixin from '@/mixins/LeanPublish';

export default {
  name: 'LeanPublish',
  mixins: [publishMixin],
  data: function () {
    return {
      active: false,
      rootPath: '',
      rootFilePath: ''
    };
  },
  props: {
    slug: {
      type: String,
      required: true
    },
    datatype: {
      type: String,
      required: true
    }
  },
  async mounted() {
    this.rootPath = `data/${this.datatype}/${this.slug}/${this.language}`;
    this.rootFilePath = `${this.rootPath}/index.json`;
    const lastPublishVersionId = (await this.$store.state.sdk.getPublishTagFromCurrentWorkspaceFile(this.rootFilePath))
      ?.Value;
    if (!lastPublishVersionId) this.active = true;
  },
  methods: {
    publish() {
      this.publishByPaths([this.rootPath]);
    }
  }
};
</script>
